import React from 'react';
import { useIntl } from 'react-intl';
import CancelIcon from '@mui/icons-material/Cancel';
import {
  FormControl,
  ListItemText,
  Typography,
  Select,
  MenuItem,
  Checkbox,
  Chip,
  Box,
} from '@mui/material';
import capitalize from '../../Helpers/StringsFormatting/capitalize';

const MultipleChipSelect = function MultipleChipSelect({
  values,
  onChange,
  options = [],
  label = '',
  CustomChip = null,
  disabled = false,
  width = '100%',
  size = 'medium',
}) {
  const intl = useIntl();

  const ChipComponent = CustomChip ?? Chip;

  const handleRemoveItem = (e, value) => {
    e.preventDefault();
    if (onChange) onChange(values.filter((v) => v !== value));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: width,
      }}
    >
      <Typography sx={{ fontSize: '14px' }}>{label}</Typography>
      <FormControl fullWidth size={size}>
        <Select
          id="label"
          value={values}
          disabled={disabled}
          multiple
          onChange={(e) => {
            if (onChange) {
              onChange(e.target.value);
            }
          }}
          renderValue={(selected) => (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 0.5,
                maxHeight: '56px',
                overflowY: 'auto',
              }}
            >
              {selected?.map((value) => {
                const objectValue = options?.find((x) => x?.value === value);

                const chipLabel = objectValue
                  ? intl.messages[objectValue?.label]
                    ? intl.messages[objectValue?.label]
                    : objectValue?.label
                  : intl.messages[value]
                    ? intl.messages[value]
                    : value;

                return (
                  <ChipComponent
                    clickable
                    size="small"
                    key={chipLabel}
                    label={capitalize(chipLabel, false)}
                    deleteIcon={
                      <CancelIcon
                        onMouseDown={(event) => event.stopPropagation()}
                      />
                    }
                    onDelete={(e) => handleRemoveItem(e, value)}
                    {...(objectValue?.chipProps || {})}
                  />
                );
              })}
            </Box>
          )}
        >
          {options.map((x) => (
            <MenuItem key={x?.value ?? x} value={x?.value ?? x}>
              <Checkbox
                checked={Boolean(
                  (values || [])?.find(
                    (item) => item === x || item === x?.value
                  )
                )}
              />
              <ListItemText
                primary={
                  (intl.messages[x?.label ?? x] ?? x?.label ?? x) ||
                  intl.messages.NO_SELECTION
                }
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default MultipleChipSelect;
